import {Injectable} from "@angular/core";


@Injectable()
export class KeyStaffDropdownCacheService {

  contextApi = '/api';
  constructor() {}

  private cache: string[] = [];

  public getCache(): string[] {
    return this.cache;
  }
}

